import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const Primary2Icon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.7408 2.44077C11.4754 1.84532 12.5267 1.8458 13.2608 2.44192L15.2789 4.0806L17.8542 4.3499C18.7912 4.44787 19.5327 5.18643 19.6345 6.123L19.9161 8.71405L21.5537 10.7477C22.1437 11.4804 22.1433 12.5252 21.5528 13.2575L19.9226 15.2792L19.6496 17.8707C19.5507 18.809 18.8096 19.5505 17.8715 19.65L15.2843 19.9244L13.2534 21.5568C12.5213 22.1453 11.4782 22.1449 10.7464 21.5559L8.71818 19.9235L6.13363 19.6425C5.2003 19.541 4.46316 18.804 4.36152 17.8707L4.07955 15.2815L2.45853 13.2361C1.88019 12.5064 1.88196 11.4741 2.4628 10.7463L4.07426 8.72722L4.35631 6.13156C4.45786 5.19705 5.19649 4.45938 6.13113 4.35904L8.71646 4.0815L10.7408 2.44077Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

Primary2Icon.propTypes = {
  ...sizePropsTypes,
};

export default memo(Primary2Icon);
